import { render, staticRenderFns } from "./DialogConfirmarAlteracoes.vue?vue&type=template&id=599e5240&"
import script from "./DialogConfirmarAlteracoes.vue?vue&type=script&lang=js&"
export * from "./DialogConfirmarAlteracoes.vue?vue&type=script&lang=js&"
import style0 from "./DialogConfirmarAlteracoes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VDialog,VFlex,VLayout,VRow,VSpacer})
